<template>
  <div class="main">
    <div class="columns is-centered">
      <div class="column is-one-third">
        <div class="parent">
          <img class="image" src="../assets/nologo.png" alt="KNOSIS">
          <img class="imagespin" src="../assets/logo.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
      }
    },
    methods: {
      goToLogin() {
        setTimeout(this.toLogin, 5000)
      },
      toLogin() {
        this.$router.push({path: '/login'})
      }
    },
    mounted() {
      this.goToLogin()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  height: 102%;
  background-color: black;
  background-size: cover;
  background-attachment: scroll;
}
.parent {
  position: relative;
  width: 500px;
  margin: 0 auto;
}
.image {
  width: 620px;
  position: relative;
  margin: 0 auto;
}
.imagespin {
  position: absolute;
  top: 55%;
  right: 200px;
  width: 120px;
  height: 120px;
  margin:-60px 0 0 -60px;
  -webkit-animation:spin 3s linear infinite;
  -moz-animation:spin 3s linear infinite;
  animation:spin 3s linear infinite;
}
@-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
@-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
@keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }
@media only screen and (max-width: 625px) {
  .main {
    width: 625px;
    height: 105%;
    background-color: black;
    background-size: cover;
    background-attachment: scroll;
  }
  .parent {
    position: relative;
    width: 500px;
    margin: 0 auto;
  }
  .image {
    width: 310px;
    position: relative;
    margin: 0 auto;
  }
  .imagespin {
    position: absolute;
    top: 65%;
    right: 220px;
    width: 70px;
    height: 70px;
    margin:-60px 0 0 -60px;
    -webkit-animation:spin 3s linear infinite;
    -moz-animation:spin 3s linear infinite;
    animation:spin 3s linear infinite;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue